var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSmile = function SvgSmile(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "154px",
    height: "191px",
    viewBox: "0 0 154 191",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Scan")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD79-Creator",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Objects",
    transform: "translate(-2552.000000, -423.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Scan",
    transform: "translate(2552.752000, 423.017000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    transform: "translate(39.590000, 73.067000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_234",
    cx: 5.439,
    cy: 5.371,
    r: 5.305
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_235",
    cx: 61.673,
    cy: 5.371,
    r: 5.305
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.652,57.401 C15.832,57.401 7.879,37.937 7.799,37.737 L9.441,37.088 C9.516,37.279 17.231,55.943 37.299,55.63 C57.308,55.223 60.771,37.436 60.805,37.256 L62.54,37.571 C62.504,37.771 58.768,56.958 37.333,57.396 C37.107,57.399 36.877,57.401 36.652,57.401 Z",
    id: "Path_1948"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    transform: "translate(0.248000, 0.983000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.735,0 L138.17,0 C137.075903,0.0637200547 136.221294,0.969549067 136.221294,2.0655 C136.221294,3.16145093 137.075903,4.06727995 138.17,4.131 L147.77,4.131 L147.77,14.247 C147.72981,14.9731175 148.094345,15.6619553 148.717336,16.0371151 C149.340326,16.412275 150.119674,16.412275 150.742664,16.0371151 C151.365655,15.6619553 151.73019,14.9731175 151.69,14.247 L151.69,2.067 C151.715275,0.958522687 150.843166,0.0364513873 149.735,0 L149.735,0 Z",
    id: "Path_1949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.962,0 L13.524,0 C14.618097,0.0637200547 15.4727056,0.969549067 15.4727056,2.0655 C15.4727056,3.16145093 14.618097,4.06727995 13.524,4.131 L3.924,4.131 L3.924,14.247 C3.96420012,14.9734813 3.59947617,15.6626595 2.97617239,16.0380042 C2.35286861,16.4133488 1.57313139,16.4133488 0.949827608,16.0380042 C0.32652383,15.6626595 -0.0382001186,14.9734813 0.002,14.247 L0.002,2.067 C-0.0221332518,0.957057992 0.852342555,0.0348429443 1.962,0 Z",
    id: "Path_1950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.735,188.017 L138.17,188.017 C137.069266,187.962813 136.20463,187.054567 136.20463,185.9525 C136.20463,184.850433 137.069266,183.942187 138.17,183.888 L147.77,183.888 L147.77,173.77 C147.72981,173.043883 148.094345,172.355045 148.717336,171.979885 C149.340326,171.604725 150.119674,171.604725 150.742664,171.979885 C151.365655,172.355045 151.73019,173.043883 151.69,173.77 L151.69,185.952 C151.715257,187.060128 150.842851,187.981621 149.735,188.017 Z",
    id: "Path_1951"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.962,188.017 L13.524,188.017 C14.6247337,187.962813 15.4893695,187.054567 15.4893695,185.9525 C15.4893695,184.850433 14.6247337,183.942187 13.524,183.888 L3.924,183.888 L3.924,173.77 C3.96420012,173.043519 3.59947617,172.35434 2.97617239,171.978996 C2.35286861,171.603651 1.57313139,171.603651 0.949827608,171.978996 C0.32652383,172.35434 -0.0382001186,173.043519 0.002,173.77 L0.002,185.952 C-0.0221161307,187.061594 0.852658203,187.983231 1.962,188.017 L1.962,188.017 Z",
    id: "Path_1952"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smile.e75920c2.svg";
export { ForwardRef as ReactComponent };